<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCliente" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">

							<p class="text-uppercase text-sm">Datos del contacto</p>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label for="Nombres">Tipo de Evento</label>
									<select v-model="objCliente.IdTipoEvento" @change="SetearEtiqueta()" class="form-control-search form-select">
										<option value="0">Seleccione una opción</option>
										<option v-for="(item,index) in ListaTiposDeEventos" :key="index" :value="item.IdTipoEvento">{{item.Nombre}}</option>
									</select>
									<CValidation v-if="this.errorvalidacion.TipoBoda" :Mensaje="'*'+errorvalidacion.TipoBoda[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label for="FechaReg">Fecha Principal</label>
									<div class="calendar">
										<Datepicker v-model="objCliente.FechaBoda" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00"></Datepicker>
									</div>
									<CValidation v-if="this.errorvalidacion.FechaBoda" :Mensaje="'*'+errorvalidacion.FechaBoda[0]"/>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label for="Nombres">{{objCliente.EtiquetaEvento}}</label>
									<input type="text" v-model="objCliente.Nombres" class="form-control" id="Nombres" :placeholder="'Ingresar '+objCliente.EtiquetaEvento" />
									<CValidation v-if="this.errorvalidacion.Nombres" :Mensaje="'*'+errorvalidacion.Nombres[0]"/>
								</div>
							</div>
		
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label for="Telefono">Teléfono</label>
									<div class="phone">
										<input type="text" v-model="objCliente.Telefono" class="form-control" id="Telefono" placeholder="Ingresar Telefono" />
									</div>
									<CValidation v-if="this.errorvalidacion.Telefono" :Mensaje="'*'+errorvalidacion.Telefono[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label for="Email">E-mail</label>
									<div class="email">
										<input type="text" v-model="objCliente.Email" class="form-control" id="Email" placeholder="Ingresar Email" />
									</div>
									<CValidation v-if="this.errorvalidacion.Email" :Mensaje="'*'+errorvalidacion.Email[0]"/>
								</div>
							</div>

							<p class="text-uppercase text-sm">Datos del cliente</p>


							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label for="IdAgente">Cliente</label>
									<select v-model="objCliente.IdAgente" @change="GetListContactos()" class="form-control-search form-select">
										<option value="0">Seleccione una opción</option>
										<option v-for="(item,index) in ListaAgentes" :key="index" :value="item.IdAgente">{{item.NombreComercial}}</option>
									</select>
									<CValidation v-if="this.errorvalidacion.IdAgente" :Mensaje="'*'+errorvalidacion.IdAgente[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-2">
									<label for="Email">Contacto Cliente</label>
									<select v-model="objCliente.IdContacto" class="form-control-search form-select">
										<option value="0">Seleccione una opción</option>
										<option v-for="(item,index) in ListaContactos" :key="index" :value="item.IdUsuario">{{item.NombreCompleto}}</option>
									</select>
									<CValidation v-if="this.errorvalidacion.IdContacto" :Mensaje="'*'+errorvalidacion.IdContacto[0]"/>
								</div>
							</div>

							<hr class="horizontal dark">
							<p class="text-uppercase text-sm">Asignacion de Evento</p>

							<div class="row g-3">
								<div class="col-12 col-sm-12 col-md-6 col-lg-4 mb-3">
									<input type="text" v-model="Vendedor" class="form-control" readonly placeholder="Selecionar Personal">
								</div>

								<div class="col-12 col-sm-12 col-md-6 col-lg-4 mb-3">
									<button type="button" @click="AgregarPersonal();" class="btn btn-primary">
										<i class="fal fa-search-plus"></i> Buscar
									</button>
								</div>
							</div>

							<div class="form-group row" style="display:none">
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<button type="button" @click="AgregarActividad({})" class="btn btn-primary">
										<i class="fa fa-plus-circle"></i> Agregar Actividad
									</button>
								</div>
							</div>

							<div class="form-group row">
								<div v-for="(item,index) in ListaEventos" :key="index" class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-1">
									<div class="card">
										<div class="card-body">
											<div class="row">
												<div class="col-12">
													<label class="col-form-label">{{item.Evento}}</label>
												</div>
												<div class="col-12">
													<label class="col-form-label">{{formatfecha(item)}}</label>
												</div>
												<div class="col-12">
													<label class="col-form-label">{{item.HoraEvento}}</label>
												</div>
											</div>
										</div>
									</div>
									
								</div>
							</div>
		
							<br>
						</div><!--fin col-12-->
					</div>
				</form>

				<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
					<template slot="Form">
						<Form :poBtnSave="oBtnSave"></Form>
					</template>
				</CModal>

				<CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
					<template slot="Form">
						<FormPersonal :poBtnSave="oBtnSave2"></FormPersonal>
					</template>
				</CModal>
			</div>
		</template>
	</CLoader>
</template>

<script>
import Calendar from '@/helpers/StaticComboBox.js';
import moment from 'moment';

import Form from '@/views/modulos/crm/cliente/FormActividad.vue';
import FormPersonal from '@/views/modulos/crm/cliente/FormPersonal.vue';
const EmitEjecuta = 'seccionActividades';
const EmitEjecuta2 = 'seccionPersonal';

export default {
    name: 'FormCliente',
    props: ['poBtnSave'],
    components:{
		Form,
		FormPersonal
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCliente: {
				IdTipoEvento: 0,
				EtiquetaEvento: 'Nombres',
				FechaBoda: '',
				IdCliente: 0,
				IdBodaCopia: 0,
				IdVendedor: 0,
				IdAgente: 0,
				IdContacto: 0,
				Nombres: '',
				Telefono: '',
				Email: '',
				Tipo: 'Prospecto',
				DeEmpresa: 0,
            },
			ConfigModal:{
                ModalTitle: "Actividades",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize: 'xl',
				FullScreen: true,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
			ConfigModal2:{
                ModalTitle: "Eventos Por Personal",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'xl',
				ShowFooter: false,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			Setpicker: Calendar.calendarSettings,
			ListaTiposDeEventos: [],
			ListaAgentes: [],
			ListaContactos: [],
			ListaEventos: [],
			Vendedor: '',
        }
    },
    methods :
    {
       	async Guardar()
        {
			if(this.objCliente.FechaBoda!=''){
				this.objCliente.FechaBoda = moment(this.objCliente.FechaBoda).format('YYYY-MM-DD');
			}

			let formData = new FormData();
			formData.set('IdCliente', this.objCliente.IdCliente);
			formData.set('Nombres', this.objCliente.Nombres);
			formData.set('Telefono', this.objCliente.Telefono);
			formData.set('Email', this.objCliente.Email);
			formData.set('Tipo', this.objCliente.Tipo);
			formData.set('IdVendedor', this.objCliente.IdVendedor);

			formData.set('IdAgente', this.objCliente.IdAgente);
			formData.set('IdContacto', this.objCliente.IdContacto);
			formData.set('TipoBoda', this.objCliente.IdTipoEvento);
			formData.set('FechaBoda', this.objCliente.FechaBoda);
			formData.set('DeEmpresa', this.objCliente.DeEmpresa);
			formData.set('ListaEventos', JSON.stringify(this.ListaEventos));

			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCliente.IdCliente == 0) {
				await this.$http.post('solicitudProspecto',formData,{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'clientes/'+this.objCliente.IdCliente,
					this.objCliente
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "clientes/"+this.objCliente.IdCliente
            ).then((res) => {
                this.objCliente = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCliente.Fecha.replace(/-/g,'\/');
                this.objCliente.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCliente = {
				IdTipoEvento: 0,
				EtiquetaEvento: 'Nombres',
				FechaBoda: '',
				IdCliente: 0,
				IdBodaCopia: 0,
				IdVendedor: 0,
				IdAgente: 0,
				IdContacto: 0,
				Nombres: '',
				Telefono: '',
				Email: '',
				Tipo: 'Prospecto',
				DeEmpresa: 0,
            }
            this.errorvalidacion = [];
			this.ListaEventos = [];
        },
		GetListTipoEventos()
		{
			this.$http.get('tipoEventos', {
				params:{
					simple: 1,
				}
			}).then( (res) => {
				this.ListaTiposDeEventos = res.data.data;
			});
		},
		SetearEtiqueta()
		{
			let buscar = this.objCliente.IdTipoEvento;

			let objv = this.ListaTiposDeEventos.filter((elem)=>{
				if(buscar == elem.IdTipoEvento) return elem;
			});

			let Etiqueta = 'Nombres';
			if(objv[0]){
				if(objv[0].Etiqueta !=''){
					Etiqueta = objv[0].Etiqueta;
				}
			}

			this.objCliente.EtiquetaEvento = Etiqueta;
		},
		GetListAgentes()
		{
			this.$http.get('agentes', {
				params:{
					simple: 1,
				}
			}).then( (res) => {
				this.ListaAgentes = res.data.data;
			}).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
		},
		GetListContactos()
		{
			if(this.objCliente.IdAgente !=0)
			{
				this.$http.get('solicitudContacto', {
					params:{
						IdAgente: this.objCliente.IdAgente,
					}
				}).then( (res) => {
					this.ListaContactos = res.data.data;
				});
			}
			else
			{
				this.objCliente.IdContacto = 0;
				this.ListaContactos = [];
			}
		},
		AgregarActividad(item)
		{
			this.bus.$emit('NewModal_'+EmitEjecuta,this.objCliente,item);
		},
		AgregarPersonal()
		{
			this.bus.$emit('NewModal_'+EmitEjecuta2,{});
		},
		formatfecha(item)
		{
			let fecha = moment(item.FechaEvento).format('YYYY-MM-DD');
			return fecha;
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
			this.GetListTipoEventos();
			this.GetListAgentes();
                
            if (Id!='') 
            {
                this.objCliente.IdCliente = Id;
                this.Recuperar();
            }
            else
            {
                //this.ConfigLoad.ShowLoader = false;
            }

			this.bus.$off('SetearEvento');
            this.bus.$on('SetearEvento',(obj)=>
            {
				console.log(obj);
                this.ListaEventos.push(obj);
            });

			this.bus.$off('SetearPersonal');
            this.bus.$on('SetearPersonal',(item)=>
            {
				this.Vendedor = item.NombreCompleto;
				this.objCliente.IdVendedor = item.IdUsuario;
            });
        });
    }
}
</script>
